import { IApiResponse } from "../../../@types/api-response.type";
import { IGroupItem } from "../../../@types/group.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const getAllGroups = async () => {
    try {
        const { data } = await Api.get("/api/Group/GetAllGroups")
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar todos os Grupos'))
    } 
}

export const getAvailableFeaturesAndAccessLevels = async () => {
    try {
        const { data } = await Api.get("/api/Group/GetAvailableFeaturesAndAccessLevels")
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar todas as telas e opções de permissão'))
    } 
}

export const deleteGroup = async (id: string) => {

    try {
      const {data} = await Api.delete(`/api/Group/DeleteGroup/${id}`);
      return data;
    } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao deletar o Grupo'))
    }
  }

  export const addOrUpdateGroup = async (group: IGroupItem) => {
    try {
        const { data } = await Api.post(`api/Group/AddOrUpdateGroup`, group)
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar Grupo'))
    }
}

export const getGroupById = async (id: string): Promise<IApiResponse<IGroupItem> | ApiException> => {

    try {
      const { data } = await Api.get<IApiResponse<IGroupItem>>(`/api/Group/GetGroupById?id=${id}`)
      return data;
  
    } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar o Grupo'))
    }
  }